import { Node, mergeAttributes } from '@tiptap/core';

/**
 * Callout Node — custom TipTap extension for colored alert/callout blocks .
 *
 * Types: info (blue), warning (orange), tip (green), danger (red)
 *
 * Usage:
 *   editor.chain().focus().setCallout({ type: 'info' }).run()
 */
const Callout = Node.create({
    name: 'callout',
    group: 'block',
    content: 'block+',
    defining: true,

    addAttributes() {
        return {
            type: {
                default: 'info',
                parseHTML: (el) => el.getAttribute('data-type') || 'info',
                renderHTML: (attrs) => ({ 'data-type': attrs.type }),
            },
        };
    },

    parseHTML() {
        return [{ tag: 'div[data-callout]' }];
    },

    renderHTML({ node, HTMLAttributes }) {
        const ICONS = {
            info: 'ℹ️',
            warning: '⚠️',
            tip: '💡',
            danger: '🚨',
        };
        const icon = ICONS[node.attrs.type] || ICONS.info;

        return [
            'div',
            mergeAttributes(HTMLAttributes, {
                'data-callout': '',
                'data-type': node.attrs.type,
                class: `tiptap-callout tiptap-callout--${node.attrs.type}`,
            }),
            ['div', { class: 'tiptap-callout__icon', contenteditable: 'false' }, icon],
            ['div', { class: 'tiptap-callout__content' }, 0],
        ];
    },

    addCommands() {
        return {
            setCallout:
                (attrs) =>
                    ({ chain }) => {
                        return chain().insertContent({
                            type: this.name,
                            attrs,
                            content: [{ type: 'paragraph' }],
                        }).run();
                    },
        };
    },

    addKeyboardShortcuts() {
        return {
            // Mod+Shift+C to insert info callout
            'Mod-Shift-c': () => this.editor.commands.setCallout({ type: 'info' }),
        };
    },
});

export default Callout;
